import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { lessonApi } from '../api/lessonBuilderApi'
import LessonCardRenderer from '../components/LessonCardRenderer'
import QuizPlayer from '../components/QuizPlayer'
import { normalizeLesson } from '../lib/sections'
import type { LessonDoc, QuizCard } from '../types/LessonDoc'

// Trang xem bài đã xuất bản (giao diện học sinh). Render bằng LessonCardRenderer —
// cùng đường render với builder, đảm bảo "xem trước = xuất bản".
const LessonViewerPage: React.FC = () => {
  const { slug } = useParams()
  const [lesson, setLesson] = useState<LessonDoc | null | undefined>(undefined)

  useEffect(() => {
    if (slug) {
      lessonApi
        .getBySlug(slug)
        .then((c) => setLesson(c ? normalizeLesson(c) : null))
        .catch(() => setLesson(null))
    }
  }, [slug])

  if (lesson === undefined) {
    return <div className="p-10 text-center text-gray-400">Đang tải...</div>
  }

  if (!lesson) {
    return (
      <div className="p-10 text-center">
        <p className="text-gray-500 mb-4">Không tìm thấy bài giảng.</p>
        <Link to="/teacher/elearning" className="text-blue-600 font-semibold">← Về danh sách bài giảng</Link>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="bg-white border-b border-gray-100 px-4 py-3">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <Link to="/teacher/elearning" className="text-gray-400 hover:text-gray-700">
            <ArrowLeft size={20} />
          </Link>
          <h1 className="text-lg font-black text-gray-900">{lesson.meta.tieuDe}</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto p-6 space-y-8">
        {lesson.meta.moTa && <p className="text-gray-500">{lesson.meta.moTa}</p>}
        {(lesson.sections || []).map((sec, i) =>
          sec.cards.length === 0 ? null : (
            <section key={sec.id}>
              <h2 className="text-lg font-black text-blue-900 mb-3 flex items-center gap-2">
                <span className="w-7 h-7 rounded-full bg-blue-600 text-white text-sm flex items-center justify-center">
                  {i + 1}
                </span>
                {sec.title}
              </h2>
              <div className="space-y-4">
                {sec.cards.map((card) => (
                  <div key={card.id} className="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
                    {card.type === 'quiz' ? (
                      <QuizPlayer card={card as QuizCard} lessonId={lesson.id} lessonSlug={lesson.slug} />
                    ) : (
                      <LessonCardRenderer card={card} />
                    )}
                  </div>
                ))}
              </div>
            </section>
          )
        )}
      </div>
    </div>
  )
}

export default LessonViewerPage
